declare global {
	// Add global declarations. This will make the types legal when the dom-lib
	// isn't included.
	interface Window {}
	interface WindowEventMap {}
	interface HTMLElementEventMap {}
	interface AddEventListenerOptions {}
}

type SubscribeEventTarget = {
	<TType extends keyof WindowEventMap>(
		target: Window,
		type: TType,
		listener: (this: Window, ev: WindowEventMap[TType]) => any,
		options?: boolean | AddEventListenerOptions,
	): () => void
	<TType extends keyof HTMLElementEventMap, TElement extends HTMLElement>(
		target: TElement,
		type: TType,
		listener: (this: TElement, ev: HTMLElementEventMap[TType]) => any,
		options?: boolean | AddEventListenerOptions,
	): () => void
}

/**
 * Wrap addEventListener/removeEventListener in a subscription-pattern.
 *
 * Only handles Window and HTMLElement as targets currently, since it's
 * problematic to automatically create types generically. Can easily have its
 * type expanded for other targets as well.
 */
export const subscribeEventTarget: SubscribeEventTarget = (target: any, ...args: Array<any>) => {
	target.addEventListener(...args)

	return () => {
		target.removeEventListener(...args)
	}
}
